export class SessionTimer {
  /**
   *
   * @param options
   * @constructor
   */
  constructor(options) {
    if (!options) {
      throw new SessionTimerException("No options given");
    }

    if (!options.selector) {
      throw new SessionTimerException("No selector given");
    }

    if (!options.lifeTime && options.lifeTime !== 0) {
      throw new SessionTimerException("No lifeTime given");
    }

    if (!options.interval) {
      throw new SessionTimerException("No interval given");
    }

    if (options.debug) {
      this.debug = true;
    }

    this.translator = options.translator;
    this.modal = options.modal;
    this.interval = options.interval;
    this.lifeTime = options.lifeTime;
    this.sessionRefreshUrl = options.sessionRefreshUrl || "";
    this._seconds = 0;
    this._minutes = 0;
    this._domElement = null;
    this._intervalTimer = null;

    if (document.querySelector(options.selector)) {
      this._domElement = document.querySelector(options.selector);
    }

    this.events = {};

    if (!this._domElement) {
      return;
    }

    this.start();
  }

  /**
   *
   */
  start() {
    if (this.lifeTime < 604800) {
      this.injectXhr();
      this.listener();
      this.reset();
      this.countDown(0);
      this._intervalTimer = setInterval(() => {
        this.countDown(1);
      }, this.interval);
    } else {
      this.displayInfinity();
    }
  }

  displayInfinity() {
    this._domElement.innerHTML = '<li style="font-size: 22px;">∞</li>';
    this.infinityAction();
  }

  /**
   *
   * @param second
   */
  countDown(second) {
    if ((second || second === 0) && this._seconds >= 0) {
      this._seconds = this._seconds - second;
      this._minutes = Math.ceil(this._seconds / 60);

      if (this.debug) {
        console.log(this._seconds, this._minutes);
      }

      this.trigger("countdown", {
        seconds: this._seconds,
        minutes: this._minutes,
      });

      if (this.updateFunction) {
        this.updateFunction(this._seconds, this._minutes);
      } else {
        this.updateDomElement();
      }
    }

    if (this._seconds <= 0) {
      this.trigger("logout");
      this.loggedOut();
    }
  }

  /**
   *
   * @return {SessionTimer}
   */
  reset() {
    this._seconds = this.lifeTime;
    this._minutes = Math.ceil(this._seconds / 60);

    return this;
  }

  setNewTime(seconds) {
    this._seconds = seconds;
    this._minutes = Math.ceil(this._seconds / 60);

    return this;
  }

  getTime() {
    return this._seconds;
  }

  /**
   *
   * @return {SessionTimer}
   */
  stop() {
    clearInterval(this._intervalTimer);

    return this;
  }

  infinityAction() {
    this._domElement.parentElement.parentElement.dataset.originalTitle = this.translator.translate(
      "auth.session.will.never.expire"
    );
  }

  updateFunction(sec, min) {
    if (sec === 120) {
      this.modal.show();
      // $(document.querySelector("#refresh-session")).modal({
      //   keyboard: false,
      // });
    }

    // ugly hack to perform a nice and smooth switch from Minutes to 0:59 seconds
    if (sec === 60) {
      this._seconds = 59;
      sec = 59;
    }

    if (sec > 60) {
      this._domElement.parentElement.parentElement.dataset.originalTitle = this.translator.translate(
        "automatic.logout.description.minutes",
        { "%s": min }
      );
      this._domElement.innerHTML = min;
    } else {
      if (sec < 10) {
        sec = "0:0" + sec;
      } else {
        sec = "0:" + sec;
      }
      this._domElement.parentElement.parentElement.dataset.originalTitle = this.translator.translate(
        "automatic.logout.description.seconds",
        { "%s": sec }
      );
      this._domElement.innerHTML = sec;
    }
  }

  /**
   *
   */
  updateDomElement() {
    try {
      this._domElement.innerHTML = Math.ceil(this._minutes);
    } catch (e) {
      console.log(e);
    }
  }

  /**
   *
   */
  loggedOut() {
    if (this.debug) {
      console.warn("LOGGED OUT");
    }

    this.stop();
  }

  /**
   *
   * @return {SessionTimer}
   */
  injectXhr() {
    const _this = this;
    const send = window.XMLHttpRequest.prototype.send;

    const sendReplacement = function (data) {
      if (this.debug) {
        console.warn("Sending HTTP request data : ", data);
      }

      if (this.onreadystatechange) {
        this._onreadystatechange = this.onreadystatechange;
      }

      this.onreadystatechange = onReadyStateChangeReplacement;

      return send.apply(this, arguments);
    };

    const onReadyStateChangeReplacement = function () {
      if (this.debug) {
        console.warn("HTTP request ready state changed : " + this.readyState);
      }

      if (this.readyState === 4) {
        _this.reset();
        _this.trigger("sessionUpdate", _this._seconds);
      }

      if (this._onreadystatechange) {
        return this._onreadystatechange.apply(this, arguments);
      }
    };

    window.XMLHttpRequest.prototype.send = sendReplacement;

    return this;
  }

  /**
   *
   */
  triggerXhrCall() {
    const xhr = new XMLHttpRequest();
    xhr.open("get", this.sessionRefreshUrl);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();

    if (this.debug) {
      console.log("triggerXhrCall");
    }
  }

  /**
   *
   */
  listener() {
    if (this._domElement.parentElement) {
      this._domElement.parentElement.onclick = () => {
        this.triggerXhrCall();
      };

      return;
    }

    this._domElement.onclick = () => {
      this.triggerXhrCall();
    };
  }

  /**
   * Little helper to define something
   * like "listeners"
   * @param eventName
   * @param func
   */
  on(eventName, func) {
    if (eventName && func) {
      this.events[eventName] = func;
    }

    return this;
  }

  /**
   * this triggers an event
   * @param eventName
   * @param data
   */
  trigger(eventName, data) {
    if (this.events[eventName] && typeof this.events[eventName] === "function") {
      this.events[eventName](data);
    }
  }
}

/**
 *
 * @param message
 * @constructor
 */
class SessionTimerException {
  constructor(message) {
    this.name = "SessionTimerException";
    this.message = message || "";
    this.stack = new Error().stack;
  }
}
